import React from "react";
import { combineProps } from "../../../../helpers/objectHelper";
import { ButtonOptionQuestion } from "./ButtonOptionQuestion";
import { NoQuestionPlaceholder } from "./NoQuestionPlaceholder";
import { TextQuestion } from "./TextQuestion";

export function Question(props) {
  const { questionList, pageNo } = props;
  if (!questionList[pageNo - 1]) return null;
  const { question } = questionList[pageNo - 1];
  switch (question.type) {
    case "Option":
      //Villkor för vad som ska ritas ut
      /*  return <ButtonOptionsQuestion {...props} />; */
      return <ButtonOptionQuestion {...combineProps([props, { question }])} />;
    case "Text":
      return <TextQuestion {...combineProps([props, { question }])} />;
    default:
      return <NoQuestionPlaceholder {...props} />;
  }
}
